import React from 'react';
import { StyledStep } from './styled';
export function Step({ legendProps, children }) {
    return React.createElement(StyledStep, { onClick: legendProps === null || legendProps === void 0 ? void 0 : legendProps.onClick }, children);
}
